import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/facturacion/facturaFEL_BS';
import Facturas from './FacturaBienesServiciosTabs';


const ms2p = (state) => {
  return {
    ...state.factura_fel_BS,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Facturas);